export default __webpack_public_path__ + "static/media/klassischeMassage.13b8216e.jpg";